import { AppState } from "store/AppState"

export const selectBulletinPending = (s: AppState) =>
  s.newsletter.bulletins.pending
export const selectBulletinFetchError = (s: AppState) =>
  s.newsletter.bulletins.error

export const selectBulletinList = (s: AppState) =>
  s.newsletter.bulletins.data || []
